export type DocumentType =
  | "DEV"
  | "CP"
  | "FIC"
  | "SEPA"
  | "CG"
  | "ATTSCO"
  | "ATTASSU"
  | "DIPA"
  | "CERTDECES"
  | "ATTESTDECES"
  | "CERTVENTEBIEN"
  | "JUSTIFDEM"
  | "ETATLIEUX"
  | "ATTESTDISPRISQUE"
  | "AvisEcheance"
  | "AUTRE";

export const DocumentType = {
  DEV: "DEV" as DocumentType,
  CP: "CP" as DocumentType,
  DIPA: "DIPA" as DocumentType,
  FIC: "FIC" as DocumentType,
  FS: "FS" as DocumentType,
  SEPA: "SEPA" as DocumentType,
  CG: "CG" as DocumentType,
  ATTSCO: "ATTSCO" as DocumentType,
  ATTASSU: "ATTASSU" as DocumentType,
  CERTDECES: "CERTDECES" as DocumentType,
  ATTESTDECES: "ATTESTDECES" as DocumentType,
  CERTVENTEBIEN: "CERTVENTEBIEN" as DocumentType,
  JUSTIFDEM: "JUSTIFDEM" as DocumentType,
  ETATLIEUX: "ETATLIEUX" as DocumentType,
  ATTESTDISPRISQUE: "ATTESTDISPRISQUE" as DocumentType,
  AVIECHEANCE: "AvisEcheance" as DocumentType,
  AUTRE: "AUTRE" as DocumentType,
};
